import {useSelector} from "react-redux";
import React from "react";
import UploadMultipleImageSlider from "./upload-multiple-image-slider";

const InputImage = ({fieldList}) => {
    const {avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)

    return (
        <div className={"col space-y-2"}>
            <div className={"row items-center space-x-4"}>
                <label htmlFor={fieldList.key} className={"font-semibold text-monstera"}>{fieldList.label}</label>
            </div>
            <UploadMultipleImageSlider itemKey={fieldList.key}/>
            {avoskinTrailRunErrorMessage[fieldList.key] && <p className={"font-semibold text-red-600 italic"}>{avoskinTrailRunErrorMessage[fieldList.key]}</p>}
        </div>
    )
}

export default InputImage
